// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a3a42324","404":"7521dc06"}[chunkId] + ".chunk.js";
};